module.exports = __webpack_public_path__ + "c4ed2390b8880049113ca6b174e5393e.ttf";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/fonts/Avenir-Roman.ttf
// module id = 644
// module chunks = 0